/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';


import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule, NgxUiLoaderConfig, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { ToastrModule } from 'ngx-toastr';
//import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { LoginComponent } from './login/login.component';
import { AssetVerificationComponent } from './asset-verification/asset-verification.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

// import { SpreadsheetAllModule } from '@syncfusion/ej2-angular-spreadsheet';
import { NgCircleProgressModule } from 'ng-circle-progress';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  //blur: 5,
  bgsOpacity: 100,
  bgsColor: '#004F69',
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 60,
  bgsType: SPINNER.ballScaleMultiple, // background spinner type
  fgsSize: 120,
  fgsColor: '#7197DF',
  fgsType: SPINNER.wanderingCubes, // foreground spinner type ballScaleMultiple
  fgsPosition: POSITION.centerCenter,
  //fgsSize: 0,
  // logoSize: 150,
  // logoPosition: POSITION.centerCenter,
  //logoUrl: '../assets/images/network-rail-logo.gif',
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 5, // progress bar thickness
  pbColor: '#004F69',
  overlayColor: 'rgba(40,40,40,.2)',
  text : 'PROCESSING...'
};

 




@NgModule({
  declarations: [AppComponent, LoginComponent, AssetVerificationComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    ToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',

    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NbEvaIconsModule,
     NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    NgxUiLoaderHttpModule.forRoot({ showForeground: true }),
    NbToastrModule.forRoot(),
    NgIdleKeepaliveModule.forRoot()  ,

    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    })

    // SpreadsheetAllModule                          ,
  ],
  bootstrap: [AppComponent],
   providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
})
export class AppModule {
}
